export const PublicPrefix = ''

export const PublicPath = {
  Root: '/',
  Login: '/login',
  ForgotPassword: '/forgot-password',
  ResetPassword: '/reset-password',
  ChangePassword: '/change-password/:token',
}
